import React, { useState } from "react";
import CabInfoListUI from "../../ResultsPage/CabInfoList/CabInfoListUI";
import ToolTipUI from "../../../../core-components/ToolTip/ToolTipUI";
import * as S from "./ReviewCabDetails.styles";
import PremiumFeaturesUI from "../../ResultsPage/PremiumFeatures/PremiumFeaturesUI";

interface IFeat {
  text: string;
  icon: string;
}

interface IFeatures {
  title: string;
  color: Array<string>;
  feature: Array<IFeat>;
}

interface IReviewCabDetails {
  t: string;
  st: string;
  img_url: string;
  details: Array<IDetails>;
  c_a: Array<{}>;
  c_i: Array<{}>;
  category: string;
  tool_tip: string;
  h_p: string;
  fuel: { t: string; bc: string, s_i: string };
  caData: Ica;
  c_a_f: IFeatures
}

interface IDetails {
  data: string;
  icon?: string;
  tag?: string;
}

interface Ica {
  msg: string;
  ic: string;
};

const ReviewCabDetailsUI: React.FC<IReviewCabDetails> = ({
  t = "",
  st = "",
  img_url = "",
  details = [],
  c_a = [],
  c_i = [],
  category = "",
  tool_tip = "",
  h_p = "",
  fuel = {},
  caData = {},
  c_a_f = {}
}) => {
  const [tooltip, setToolTip] = useState(false);
  const [viewDetails, setDetails] = useState(true);
  const [cTooltip, cSetToolTip] = useState("");
  
  return (
    <S.Cont>
      <S.ContLeft>
        {fuel?.t ? (
          <span className="engineType bc" bc={fuel?.bc}>
            {fuel?.t}
          </span>
        ) : null}
        <S.CabImg src={img_url} />
      </S.ContLeft>
      <S.Content>
        <div className="cabDtlhHeader">
          {t ? <h4 className="cabName">{t}</h4> : null}
          {st ? (
            <div className="tagText">
              <span
                onMouseOver={() => setToolTip(true)}
                onMouseOut={() => setToolTip(false)}
              >
                {st}
              </span>
              {tooltip ? (
                <ToolTipUI title={`${t} ${st}`} data={tool_tip} />
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="cabDtlFooter">
          {category ? <span className="cabType">{category}</span> : null}
          {c_i?.length > 0 ? (
            <ul className="cabOfferings__list">
              {c_i?.map(({ id, icon, t }) => (
                <li
                  key={id}
                >
                  <img
                    src={icon}
                    style={{ height: "17px", paddingRight: "4px" }}
                  />
                  {t ? <span>{t}</span> : null}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
        {c_a?.length ? (
          <div className="safetyMeasure">
            <ul className="safetyMeasureList">
              {c_a.map(({ icon, t, key }, index) => (
                <li
                  key={`safetyMeasureList${index}`}
                  onMouseOver={() => cSetToolTip(key)}
                  onMouseOut={() => cSetToolTip("")}
                >
                  <img
                    src={icon}
                    style={{ height: "17px", paddingRight: "4px" }}
                  />
                  <span>{t}</span>
                  {cTooltip && key === cTooltip && caData?.[cTooltip] ? (
                    <S.ToolTip>
                      <ToolTipUI
                        title={caData[cTooltip].ic}
                        data={caData[cTooltip].msg}
                        showIcon={false}
                        beforeLeft={"4rem"}
                        bgColor={"#e9f6ea"}
                        borderColor={"#afdfb3"}
                        color={"#2bac36"}
                      />
                    </S.ToolTip>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        {details.length ? (
          <S.Details>
            {viewDetails ? (
              <React.Fragment>
                {c_a_f?.feature?.length > 0 ? <PremiumFeaturesUI {...c_a_f} /> : null}
                <CabInfoListUI details={details} />
              </React.Fragment>
              ) : null}
            <p>
              <span
                className={viewDetails ? "viewDtl toggleUp" : "viewDtl"}
                onClick={() => setDetails(!viewDetails)}
              >
                {viewDetails ? "Hide Details" : "View Details"}
              </span>
            </p>
          </S.Details>
        ) : null}
        {!!fuel?.s_i ? (
          <S.FuelPersuasion>{fuel?.s_i}</S.FuelPersuasion>
        ) : null}
      </S.Content>
      {h_p ? (
        <S.ContRight>
          <p className="fcText">{h_p}</p>
        </S.ContRight>
      ) : null}
    </S.Cont>
  );
};

export default ReviewCabDetailsUI;
